export default defineAppConfig({
  ui: {
    strategy: 'merge',
    primary: 'meteorite',
    gray: 'cool',
  }
})